import PropTypes from 'prop-types';
import React from 'react';
import Select from 'react-select';
import { Iterable, List } from 'immutable';
import { Row, Col, FormGroup, FormControl } from 'react-bootstrap';

const listFromSelectValues = selectVals => new List(selectVals).map(x => x.value);

const SYNC_STATUS_OPTIONS = [
  { value: 'loaded', label: 'Loaded' },
  { value: 'failed', label: 'Failed' },
];

const SyncFilter = ({ filters, updateFilter }) => {
  const onUpdateNameSearch = e => updateFilter('nameSearch', e.target.value);

  const onUpdateStatusFilter = vals => updateFilter('allowedStatuses', listFromSelectValues(vals));

  return (
    <Row>
      <Col md={2}>
        <Select
          onChange={onUpdateStatusFilter}
          options={SYNC_STATUS_OPTIONS}
          value={filters.allowedStatuses.toJS()}
          multi
          autoBlur
          placeholder='STATUS'
        />
      </Col>
      <Col md={6}>
        <FormGroup>
          <FormControl
            type='text'
            placeholder='SEARCH TABLES'
            value={filters.nameSearch}
            onChange={onUpdateNameSearch}
          />
        </FormGroup>
      </Col>
    </Row>
  );
};

export default SyncFilter;

SyncFilter.propTypes = {
  filters: PropTypes.shape({
    nameSearch: PropTypes.string,
    allowedStatuses: PropTypes.instanceOf(Iterable),
  }),
  updateFilter: PropTypes.func,
};
